<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize" :layout="layout"
      :page-sizes="pageSizes" :total="total" v-bind="$attrs" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
      <span style="color: #606266;font-weight: normal;margin-right: 10px;">{{
        slots
      }}</span>
    </el-pagination>
  </div>
</template>

<script>
// import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 40, 50]
      }
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    },
    pageFlag: {
      type: String,
      default: ''
    },
    totalPage: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      toPage: 1
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    },
    slots: {
      get() {
        let temp = ''
        switch (this.pageFlag) {
          case 'detail':
          case 'aptAlarmDetail':
            temp = '总共 ' + this.total + ' 个项目'
            break
          default:
            temp =
              '共 ' +
              this.total +
              ' 条记录 ' +
              ' 第 ' +
              this.currentPage +
              ' / ' +
              (this.totalPage === 0 ? 1 : this.totalPage) +
              ' 页'
            break
        }
        return temp
      }
    },
    layout: {
      get() {
        let temp = ''
        switch (this.pageFlag) {
          case 'detail':
          case 'aptAlarmDetail':
            temp = 'slot, prev, pager, next'
            break
          default:
            temp = 'slot, prev, pager, next, sizes, jumper'
            break
        }
        return temp
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.currentPage = 1
      this.$emit('pagination', { page: 1, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    jump() {
      if (this.toPage > this.totalPage) {
        this.currentPage = this.toPage = this.totalPage
      } else {
        this.currentPage = Number(this.toPage)
      }
      this.$emit('pagination', {
        page: this.currentPage,
        limit: this.pageSize
      })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="scss">
.pagination-container {
  background: transparent;
  padding: 16px 12px 0;

  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    background: rgba(58, 176, 227, 0.15);
    border: 1px solid #3AB0E3;
    color: #fff;
  }
}

.pagination-container.hidden {
  display: none;
}

.apt-jump {
  width: 50px;
  margin: 0 3px;

  input {
    padding: 0;
  }
}

.pagination-container {
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #83E9FF;
  }

  .el-pagination {
    display: flex;
    justify-content: flex-end;
    color: #fff;

    .el-pagination__jump {
      color: #fff;
    }

    button {
      background: rgba(58, 176, 227, 0.15) !important;
      background-color: rgba(58, 176, 227, 0.15) !important;
      box-shadow: inset 0px 0px 8px 4px rgba(58, 176, 227, 0.25);
      border-radius: 2px 2px 2px 2px;
      opacity: 1;
      border: 1px solid #3AB0E3 !important;
      font-weight: 400;
      color: #FFFFFF;
      padding: 5px 10px;

      &:hover {
        color: #ffffff;
        background: transparent;
        border: 1px solid #83E9FF;
      }

      &:active {
        color: #ffffff;
        background: transparent;
        border: 1px solid #83E9FF;
      }

      &:focus {
        color: #ffffff;
        background: transparent;
        border: 1px solid #83E9FF;
      }
    }

    .el-input__inner {
      border-radius: 2px 2px 2px 2px;
      opacity: 1;
      border: 1px solid #3AB0E3;
      background-color: transparent;
      color: #fff;
    }
  }
}
</style>
